import { useFeatureFlag } from '@betterment/shared-components';

import { Nav } from '../../../Shared/components-v2/nav/Nav';
import { NavLink } from '../nav-link/NavLink';

export const ActivityNav = () => {
  const { enabled: isActivityRefreshFeatureFlagEnabled } = useFeatureFlag({
    splitName: 'retail.activity_refresh_q1_2025_enabled',
    context: 'ActivityLinkSideBar',
  });

  const { enabled: isEnvelopesExperienceEnabled } = useFeatureFlag({
    splitName: 'retail.envelopes_experience_q1_2025_enabled',
    context: 'ActivityLinkSideBar',
  });

  return (
    <>
      <Nav.Separator />
      <Nav aria-label="Your Activity">
        <Nav.List>
          <Nav.ListItem key="performance">
            <NavLink to="/performance">
              <NavLink.Icon name="Bar" />
              <NavLink.Text>Performance</NavLink.Text>
            </NavLink>
          </Nav.ListItem>
          <Nav.ListItem key="activity">
            {isActivityRefreshFeatureFlagEnabled && isEnvelopesExperienceEnabled ? (
              <NavLink to="/activity">
                <NavLink.Icon name="List" />
                <NavLink.Text>Activity</NavLink.Text>
              </NavLink>
            ) : (
              <NavLink to="/activity_transactions" reloadDocument={true}>
                <NavLink.Icon name="List" />
                <NavLink.Text>Activity</NavLink.Text>
              </NavLink>
            )}
          </Nav.ListItem>
          <Nav.ListItem key="transfers">
            <NavLink to="/transfers/new_transfer">
              <NavLink.Icon name="Transfer" />
              <NavLink.Text>Transfers</NavLink.Text>
            </NavLink>
          </Nav.ListItem>
          <Nav.ListItem key="documents">
            <NavLink to="/documents">
              <NavLink.Icon name="Document" />
              <NavLink.Text>Documents</NavLink.Text>
            </NavLink>
          </Nav.ListItem>
        </Nav.List>
      </Nav>
    </>
  );
};
